/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Selectplan1Inputs */

const zh_subscription_selectplan1 = /** @type {(inputs: Subscription_Selectplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择计划`)
};

const en_subscription_selectplan1 = /** @type {(inputs: Subscription_Selectplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select Plan`)
};

const es_subscription_selectplan1 = /** @type {(inputs: Subscription_Selectplan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar plan`)
};

/**
* | output |
* | --- |
* | "Select Plan" |
*
* @param {Subscription_Selectplan1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscription_selectplan1 = /** @type {((inputs?: Subscription_Selectplan1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Selectplan1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_subscription_selectplan1(inputs)
	if (locale === "en") return en_subscription_selectplan1(inputs)
	return es_subscription_selectplan1(inputs)
});
export { subscription_selectplan1 as "subscription_selectPlan" }